export default {
    CaReceipt: 0, 
    CaReceiptTwo: 1, 
    CaReceiptMLNS: 2,
    CaReceiptA5: 3,
    CaReceiptA5A4: 4, 
};